// import { width } from '@mui/system';
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, NavLink, useHistory } from 'react-router-dom'

import '../Components/Component-css/Header.css'
import css from './Component-css/Nav.module.css'
import BottonMenu from '../uiComponents/BottonMenu'
import { IoMdNotificationsOutline } from 'react-icons/io'
import { FiPlus } from 'react-icons/fi'
import '../Components/Component-css/Header.css'
import { IoIosAdd } from "react-icons/io";
import Swal from 'sweetalert2';

const w3_close = () => {
  const width = document.getElementById('mySidebar').offsetWidth
  document.getElementById('mySidebar').style.left = `-${width}px`
  document.getElementById('sidebarOverlay').style.display = 'none'
}
const w3_open = () => {
  document.getElementById('mySidebar').style.left = '0'
  document.getElementById('sidebarOverlay').style.display = 'block'
}

const addsetting = localStorage.getItem('sitSetting')
const udata = localStorage.getItem('udata')
const addCaseSetting = JSON.parse(addsetting)


const Header = ({ user }) => {
  // console.log(user)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [isdropdownVisible, setIsdropdownVisible] = useState(false)

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible)
  }

  const history = useHistory()

  let access_token = localStorage.getItem('token')
  access_token = localStorage.getItem('token')

  const logout = () => {
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios
      .post(
        baseUrl + `logout`,
        {
          headers: headers
        },
        { headers }
      )
      .then(res => {
        // setUser(res.data)
        localStorage.removeItem('token')
        localStorage.removeItem('phone')
        window.location.reload()
        history.push('/')
      })
      .catch(e => {
        if (e.response.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          localStorage.removeItem('phone')
        }
      })
  }

  //  Download App
  const [promptInstall, setPromptInstall] = useState(null)

  useEffect(() => {
    const handler = e => {
      e.preventDefault()
      setPromptInstall(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    return () => window.removeEventListener('transitionend', handler)
  }, [])

  const onClick = evt => {
    evt.preventDefault()
    if (!promptInstall) {
      return
    }
    promptInstall.prompt()
  }

  return (
    <>
      <div>
        <div className='header_top_message'>
          <span style={{ fontSize: '13px' }}>
            {JSON.parse(localStorage.getItem('sitSetting')) == 'undefined'
              ? ''
              : JSON.parse(localStorage.getItem('sitSetting'))?.header_message}
          </span>
        </div>
        {access_token ? (
          <React.Fragment>
            <div id='sidebarOverlay' onClick={w3_close}></div>
            <div
              className='w3-sidebar w3-bar-block'
              id='mySidebar'
              style={{ paddingBottom: '70px' }}
            >
              <div className='sidebar_header'>
                <h2></h2>
              </div>

              <div className="sidebar_menu_v3">

  <Link to="/Profile" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box profile_box">
      <img
        src={
          user?.avatar
            ? "/images/avatars/Avatar5.png"
            : "/images/avatars/Avatar7.png"
        }
        alt=""
      />
    </div>
    <div className="menu_content">
      <h5>My Profile</h5>
      <span>Manage account</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/landing" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/gamepad.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>Win Cash</h5>
      <span>Play battles & earn</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/wallet" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/wallet.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>My Wallet</h5>
      <span>Deposit & withdraw</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/transaction-history" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/order-history.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>History</h5>
      <span>Transactions & battles</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/Referral-history" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/refer-history.webp" alt="" />
    </div>
    <div className="menu_content">
      <h5>Refer History</h5>
      <span>Referral records</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/refer" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/sreferEarn.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>Refer & Earn</h5>
      <span>Invite friends</span>
    </div>
    <div className="reward_badge">₹</div>
  </Link>

  <Link to="/Notification" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/notifications.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>Notification</h5>
      <span>Latest updates</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

  <Link to="/support" className="sidebar_item_v3" onClick={w3_close}>
    <div className="menu_icon_box">
      <img src="/images/Header/support.png" alt="" />
    </div>
    <div className="menu_content">
      <h5>Support</h5>
      <span>Help center</span>
    </div>
    <i className="fa-solid fa-chevron-right"></i>
  </Link>

</div>
              <div
                className='w3-bar-item w3-button sidebar_link'
                onClick={toggleDiv}
              >
                <picture className='icon'>
                  <img alt='img' src='../images/icons/policy.png' />
                </picture>
                <h3>{isdropdownVisible ? 'All Policy' : 'All Policy'}</h3>
              </div>
              {isdropdownVisible && (
                <ul className='dropdown_link'>
                  <li>
                    <Link to='/privacy-policy' onClick={w3_close}>
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to='/shipping-delivery-policy' onClick={w3_close}>
                      Shipping and Delivery Policy
                    </Link>
                  </li>
                  <li>
                    <Link to='/RefundPolicy' onClick={w3_close}>
                      Refund/Cancellation Policy
                    </Link>
                  </li>
                  <li>
                    <Link to='/term-condition' onClick={w3_close}>
                      Terms &amp; Condition
                    </Link>
                  </li>

                  <li>
                    <Link to='/contact-us' onClick={w3_close}>
                      Contact
                    </Link>
                  </li>
                </ul>
              )}
            </div>


            <div className='w3-teal'>
              <div className='w3-container '>
                <div className={`${css.headerContainer} `}>
                  <button
                    className='w3-button w3-teal w3-xlarge float-left'
                    onClick={w3_open}
                    id='hambergar'
                  >
                    <picture className={`${css.sideNavIcon} mr-0`}>
                      <img
                        src={process.env.PUBLIC_URL + '/images/icons/menu.png'}
                        className='snip-img'
                        alt=''
                      />
                    </picture>
                  </button>
                  <Link to='/'>
                    <img
                      src='/logo.png'
                      className='snip-img  shdaoeimg'
                      alt='logos'
                      width='110px'

                      style={{}}
                    />
                  </Link>

                  <div className={`${css.menu_items}`}>
                    <Link
                      className={`${css.box}`}
                      to="/addcase"
                    >
                      <picture className={`${css.moneyIcon_container}`}>
                        <img
                          src={process.env.PUBLIC_URL + '/images/coin-cc.png'}
                          className='snip-img'
                          alt=''
                        />
                      </picture>
                      <div className='mt-1 ml-1'>
                        <div className={`${css.moneyBox_header}`}>Cash</div>
                        <div className={`${css.moneyBox_text}`}>
                          {user && user.Wallet_balance}
                        </div>
                      </div>
                      <picture className={`${css.moneyBox_add}`}>
                        <IoIosAdd />
                      </picture>
                    </Link>


                    <Link
                      className={`${css.box} ml-2 refer-badge`}
                      to='/redeem/refer'
                      style={{ width: '80px' }}
                    >
                      <picture className={`${css.moneyIcon_container}`}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            '/images/LandingPage_img/notification-activity-reward.png'
                          }
                          className='snip-img'
                          alt=''
                        />
                      </picture>
                      <div className='mt-1 ml-1'>
                        <div className={`${css.moneyBox_header}`}>Earning</div>
                        <div className={`${css.moneyBox_text}`}>
                          {user && user.referral_wallet}
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className='w3-teal '>
            <div className='w3-container '>
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to='/'>
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src='./logo.png'
                      className='snip-img'
                      alt='rjludo'
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type='button' className='login-btn' to='/login'>
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}


      </div>
      <div className='bottom_menus_main'>
        <BottonMenu />
      </div>
    </>
  )
}

export default Header
